import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { SystemOverview } from './components/SystemOverview';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Comparison } from './components/Comparison';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-ink font-sans text-slate-200 antialiased" data-id="element-0" data-mp="28tmex2vosax8">
      <Hero data-id="element-1" data-mp="23vkzqt1dsvr1" />
      <main data-id="element-2" data-mp="23w4g45bdvc2y">
        <Problems data-id="element-3" data-mp="23u9q4cl98ts0" />
        <SystemOverview data-id="element-4" data-mp="23ut9lxqjzq85" />
        <Volumes data-id="element-5" data-mp="23ti6m04xmmi3" />
        <Bonuses data-id="element-6" data-mp="3ik7ekc2063oj" />
        <Offer data-id="element-7" data-mp="3ikqz80j1f669" />
        <Comparison data-id="element-8" data-mp="3ij66mgga9xb1" />
        <Guarantee data-id="element-9" data-mp="3ijpdn24eb1aa" />
        <Testimonials data-id="element-10" data-mp="3ii4ppvcl6gle" />
        <Faq data-id="element-11" data-mp="3ml1397n9rmih" />
        <FinalCta data-id="element-12" data-mp="3mkhlps1j704z" />
      </main>
      <SiteFooter data-id="element-13" data-mp="3mjq2lgp4euvl" />
      <PurchasePopup data-id="element-14" data-mp="3mj6jvxrnc2gi" />
    </div>;
}